/**
 * TK-31 (v2026_r2) — phần THUẦN của đèn NEMA phía web: không nhập gì của trình duyệt, để bộ kiểm
 * máy chủ (`server/src/scripts/kiem-tk31.ts`) chấm thẳng hàm thật, không chấm bản chép.
 */

export type TrangThaiNema = 'dang-kiem' | 'tat' | 'bat';

export interface NemaBat {
  bat: true;
  /** Đường thử ingest (bộ giả lập / nema-bridge) có mở không. */
  dev: boolean;
}

/**
 * 🔴 LUẬT SỐ 0 — BA trạng thái. CHỈ đúng 404 mới là 'tat' (máy chủ beta không có route NEMA).
 * Lỗi khác (mạng, 500, 401…) chưa nói được máy chủ có NEMA hay không ⇒ 'dang-kiem'.
 */
export function trangThaiNema(duLieu: NemaBat | undefined, loi: unknown): TrangThaiNema {
  if (duLieu && duLieu.bat === true) return 'bat';
  const s = (loi as { status?: number } | null | undefined)?.status;
  if (s === 404) return 'tat';
  return 'dang-kiem';
}
